import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "searchBtn",
    "navBtn",
    "header",
    "categoryNav",
    "nav",
    "btnLeft",
    "btnRight",
  ];

  connect() {
    this.updateBodyClass();

    if (this.hasHeaderTarget && this.hasCategoryNavTarget) {
      this.headerHeight = this.headerTarget.offsetHeight;
      this.navOffsetTop = this.categoryNavTarget.offsetTop;
      this.handleScroll = this.toggleFixedClass.bind(this);
      window.addEventListener("scroll", this.handleScroll);
    }

    if (this.hasNavTarget && this.hasBtnLeftTarget && this.hasBtnRightTarget) {
      this.scrollAmount = 150;
      this.checkScrollPosition = this.checkScrollPosition.bind(this);
      this.btnLeftTarget.addEventListener("click", this.scrollLeft.bind(this));
      this.btnRightTarget.addEventListener(
        "click",
        this.scrollRight.bind(this)
      );
      this.navTarget.addEventListener("scroll", this.checkScrollPosition);
      window.addEventListener("resize", this.checkScrollPosition);

      // Drag scroll
      this.isDown = false;
      this.navTarget.addEventListener("mousedown", this.handleMouseDown);
      this.navTarget.addEventListener("mouseleave", this.handleMouseLeave);
      this.navTarget.addEventListener("mouseup", this.handleMouseUp);
      this.navTarget.addEventListener("mousemove", this.handleMouseMove);

      // Touch scroll
      this.navTarget.addEventListener("touchstart", this.handleTouchStart);
      this.navTarget.addEventListener("touchmove", this.handleTouchMove);

      this.checkScrollPosition();
    }
  }

  disconnect() {
    if (this.handleScroll) {
      window.removeEventListener("scroll", this.handleScroll);
    }

    if (this.hasNavTarget && this.hasBtnLeftTarget && this.hasBtnRightTarget) {
      this.btnLeftTarget.removeEventListener("click", this.scrollLeft);
      this.btnRightTarget.removeEventListener("click", this.scrollRight);
      this.navTarget.removeEventListener("scroll", this.checkScrollPosition);
      window.removeEventListener("resize", this.checkScrollPosition);

      this.navTarget.removeEventListener("mousedown", this.handleMouseDown);
      this.navTarget.removeEventListener("mouseleave", this.handleMouseLeave);
      this.navTarget.removeEventListener("mouseup", this.handleMouseUp);
      this.navTarget.removeEventListener("mousemove", this.handleMouseMove);
      this.navTarget.removeEventListener("touchstart", this.handleTouchStart);
      this.navTarget.removeEventListener("touchmove", this.handleTouchMove);
    }
  }

  toggleSearch() {
    setTimeout(() => {
      if (this.searchBtnTarget.checked) {
        this.navBtnTarget.checked = false;
      }
      this.updateBodyClass();
    }, 0);
  }

  toggleNav() {
    setTimeout(() => {
      if (this.navBtnTarget.checked) {
        this.searchBtnTarget.checked = false;
      }
      this.updateBodyClass();
    }, 0);
  }

  closeAll() {
    this.searchBtnTarget.checked = false;
    this.navBtnTarget.checked = false;
    this.updateBodyClass();
  }

  updateBodyClass() {
    if (this.searchBtnTarget.checked || this.navBtnTarget.checked) {
      document.body.classList.add("open-gnav");
    } else {
      document.body.classList.remove("open-gnav");
    }
  }

  toggleFixedClass() {
    if (window.scrollY >= this.navOffsetTop - this.headerHeight) {
      this.categoryNavTarget.classList.add("is-fixed");
    } else {
      this.categoryNavTarget.classList.remove("is-fixed");
    }
  }

  checkScrollPosition() {
    const maxScrollLeft =
      this.navTarget.scrollWidth - this.navTarget.clientWidth;
    const scrollLeft = this.navTarget.scrollLeft;
    this.btnLeftTarget.classList.toggle("is-hidden", scrollLeft <= 0);
    this.btnRightTarget.classList.toggle(
      "is-hidden",
      scrollLeft >= maxScrollLeft - 1
    );
    this.navTarget.classList.toggle("has-left", scrollLeft > 0);
    this.navTarget.classList.toggle(
      "has-right",
      scrollLeft < maxScrollLeft - 1
    );
  }

  scrollLeft() {
    this.navTarget.scrollBy({ left: -this.scrollAmount, behavior: "smooth" });
  }

  scrollRight() {
    this.navTarget.scrollBy({ left: this.scrollAmount, behavior: "smooth" });
  }

  handleMouseDown(e) {
    this.isDown = true;
    this.navTarget.classList.add("is-dragging");
    this.startX = e.pageX - this.navTarget.offsetLeft;
    this.scrollLeftStart = this.navTarget.scrollLeft;
  }

  handleMouseLeave() {
    this.isDown = false;
    if (this.hasNavTarget && this.navTarget.classList.contains("is-dragging")) {
      this.navTarget.classList.remove("is-dragging");
    }
  }

  handleMouseUp() {
    this.isDown = false;
    if (this.hasNavTarget && this.navTarget.classList.contains("is-dragging")) {
      this.navTarget.classList.remove("is-dragging");
    }
  }

  handleMouseMove(e) {
    if (!this.isDown) return;
    e.preventDefault();
    const x = e.pageX - this.navTarget.offsetLeft;
    const walk = (x - this.startX) * 1.5;
    this.navTarget.scrollLeft = this.scrollLeftStart - walk;
  }

  handleTouchStart(e) {
    this.touchStartX = e.touches[0].pageX;
    this.touchScrollLeft = this.navTarget.scrollLeft;
  }

  handleTouchMove(e) {
    const touchX = e.touches[0].pageX;
    const walk = (touchX - this.touchStartX) * 1.5;
    this.navTarget.scrollLeft = this.touchScrollLeft - walk;
  }
}
